// extracted by mini-css-extract-plugin
export default {"container":"Suites_container__EKSrM","rooms":"Suites_rooms__B8sbI","room":"Suites_room__j67Ie","cover":"Suites_cover__ND+l5"};